(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPetnookHeader(root) {
      var toggle = root.querySelector('.petnook-header__toggle');
      var drawer = root.querySelector('.petnook-header__drawer');

      if (!toggle || !drawer || toggle.dataset.petnookReady === 'true') return;

      toggle.dataset.petnookReady = 'true';

      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        drawer.hidden = isOpen;
      });

      drawer.addEventListener('click', function (event) {
        if (event.target.closest('a')) {
          toggle.setAttribute('aria-expanded', 'false');
          drawer.hidden = true;
        }
      });

      window.addEventListener('resize', function () {
        if (window.innerWidth >= 990) {
          toggle.setAttribute('aria-expanded', 'false');
          drawer.hidden = true;
        }
      });
    }

    function initAll() {
      document.querySelectorAll('.petnook-header').forEach(initPetnookHeader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-sell"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.trv-product').forEach(function (root) {
    var slides = root.querySelectorAll('.trv-product__slide');
    var dots = root.querySelectorAll('.trv-product__dot');
    var prevBtn = root.querySelector('.trv-product__nav--prev');
    var nextBtn = root.querySelector('.trv-product__nav--next');
    var current = 0;

    function goTo(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    var qtyInput = root.querySelector('.trv-product__qty-input');
    var qtyMinus = root.querySelector('.trv-product__qty-minus');
    var qtyPlus = root.querySelector('.trv-product__qty-plus');

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val - 1);
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    var optionSelects = root.querySelectorAll('.trv-product__select');
    var variantSelect = root.querySelector('.trv-product__variant-select');
    if (optionSelects.length && variantSelect) {
      optionSelects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          var chosen = Array.from(optionSelects).map(function (s) { return s.value; }).join(' / ');
          Array.from(variantSelect.options).forEach(function (opt) {
            if (opt.text.trim() === chosen.trim()) {
              variantSelect.value = opt.value;
            }
          });
        });
      });
    }

    var shareBtn = root.querySelector('.trv-product__share');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url = shareBtn.getAttribute('data-share-url');
        if (navigator.share) {
          navigator.share({ url: url });
        } else {
          navigator.clipboard.writeText(url);
          shareBtn.textContent = 'Copied!';
          setTimeout(function () { shareBtn.textContent = 'Share'; }, 1500);
        }
      });
    }
  });

  document.querySelectorAll('.trv-bundle').forEach(function (root) {
    var variantMapEl = root.querySelector('[data-trv-bundle-variant-map]');
    var pricesEl = root.querySelector('[data-trv-bundle-prices]');
    var variantMap = JSON.parse(variantMapEl.textContent || '[]');
    var prices = pricesEl ? JSON.parse(pricesEl.textContent || '{}') : {};
    var addBtn = root.querySelector('[data-trv-bundle-add-btn]');
    var addBtnText = root.querySelector('[data-trv-bundle-add-btn-text]');
    var errorEl = root.querySelector('[data-trv-bundle-error]');
    var radios = root.querySelectorAll('.trv-bundle__radio');
    var tiers = root.querySelectorAll('.trv-bundle__tier');

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function getSelectedTier() {
      var checked = root.querySelector('.trv-bundle__radio:checked');
      return checked ? checked.value : '1';
    }

    function updateButtonLabel() {
      var tier = getSelectedTier();
      var count = parseInt(tier, 10) || 1;
      var label = 'Add ' + count + ' to cart';
      if (prices[tier]) {
        label += ' · ' + formatMoney(prices[tier]);
      }
      addBtnText.textContent = label;
    }

    // Make the whole tier card selectable, not just the tiny hidden radio.
    tiers.forEach(function (tierEl) {
      tierEl.addEventListener('click', function (e) {
        // Let native clicks on the color <select> dropdowns behave normally.
        if (e.target.tagName === 'SELECT' || e.target.closest('select')) return;
        var radio = tierEl.querySelector('.trv-bundle__radio');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        errorEl.hidden = true;
        updateButtonLabel();
      });
    });

    updateButtonLabel();

    function findVariant(color) {
      for (var i = 0; i < variantMap.length; i++) {
        if (variantMap[i].color === color) return variantMap[i];
      }
      if (variantMap.length === 1) return variantMap[0];
      return null;
    }

    function collectItems() {
      var tier = getSelectedTier();
      var quantities = {};

      function addQty(id, qty) {
        quantities[id] = (quantities[id] || 0) + qty;
      }

      if (tier === '1') {
        var v = variantMap[0];
        if (!v) return { error: 'This product has no available variants.' };
        if (!v.available) return { error: 'That option is currently out of stock.' };
        addQty(v.id, 1);
      } else {
        var tierEl = root.querySelector('[data-trv-bundle-tier="' + tier + '"]');
        var selects = tierEl.querySelectorAll('[data-trv-bundle-color-select]');
        for (var i = 0; i < selects.length; i++) {
          var color = selects[i].value;
          var variant = findVariant(color);
          if (!variant) return { error: 'Could not match "' + color + '" to a variant.' };
          if (!variant.available) return { error: 'The ' + color + ' option is currently out of stock.' };
          addQty(variant.id, 1);
        }
      }

      var items = Object.keys(quantities).map(function (id) {
        return { id: parseInt(id, 10), quantity: quantities[id] };
      });
      return { items: items };
    }

    addBtn.addEventListener('click', function () {
      errorEl.hidden = true;
      var result = collectItems();
      if (result.error) {
        errorEl.textContent = result.error;
        errorEl.hidden = false;
        return;
      }

      var defaultLabel = addBtnText.textContent;
      addBtn.disabled = true;
      addBtnText.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: result.items })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (e) { throw new Error(e.description || 'Could not add to cart.'); });
          return res.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error('Bundle add to cart failed:', err);
          errorEl.textContent = err.message || 'Something went wrong. Please try again.';
          errorEl.hidden = false;
          addBtn.disabled = false;
          addBtnText.textContent = defaultLabel;
        });
    });

    var timerEl = root.querySelector('[data-trv-bundle-timer]');
    if (timerEl) {
      var minutes = parseInt(timerEl.getAttribute('data-minutes'), 10) || 15;
      var secondsLeft = minutes * 60;
      var textEl = root.querySelector('[data-trv-bundle-timer-text]');
      var tick = function () {
        if (secondsLeft <= 0) { secondsLeft = minutes * 60; }
        var m = Math.floor(secondsLeft / 60);
        var s = secondsLeft % 60;
        textEl.textContent = m + ':' + (s < 10 ? '0' + s : s);
        secondsLeft--;
      };
      tick();
      setInterval(tick, 1000);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petnook-featured-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.petnook-featured').forEach(function (root) {
    var slides = root.querySelectorAll('.petnook-featured__slide');
    var dots = root.querySelectorAll('.petnook-featured__dot');
    var prevBtn = root.querySelector('.petnook-featured__nav--prev');
    var nextBtn = root.querySelector('.petnook-featured__nav--next');
    var current = 0;

    function goTo(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
        d.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    var qtyInput = root.querySelector('.petnook-featured__qty-input');
    var qtyMinus = root.querySelector('.petnook-featured__qty-minus');
    var qtyPlus = root.querySelector('.petnook-featured__qty-plus');

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val - 1);
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    var optionSelects = root.querySelectorAll('.petnook-featured__select');
    var variantSelect = root.querySelector('.petnook-featured__variant-select');
    if (optionSelects.length && variantSelect) {
      optionSelects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          var chosen = Array.from(optionSelects).map(function (s) { return s.value; }).join(' / ');
          Array.from(variantSelect.options).forEach(function (opt) {
            if (opt.text.trim() === chosen.trim()) {
              variantSelect.value = opt.value;
            }
          });
        });
      });
    }

    var shareBtn = root.querySelector('.petnook-featured__share');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url = shareBtn.getAttribute('data-share-url');
        if (navigator.share) {
          navigator.share({ url: url });
        } else {
          navigator.clipboard.writeText(url);
          shareBtn.textContent = 'Copied!';
          setTimeout(function () { shareBtn.textContent = 'Share'; }, 1500);
        }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Formulario 2: Tracking Number -> Australia Post (funciona sin app)
  var form2 = document.getElementById('track-order-form-2');
  if (form2) {
    form2.addEventListener('submit', function(e) {
      e.preventDefault();
      var trackingNum = document.getElementById('tracking-number').value.trim();
      if (!trackingNum) {
        alert('Please enter a tracking number');
        return;
      }
      window.open('https://auspost.com.au/track/' + encodeURIComponent(trackingNum), '_blank');
    });
  }

  // Formulario 1: Order Number + Email -> lleva a la cuenta de Shopify
  // (verificacion real por order+email requiere una app de tracking, ej. AfterShip/Track123)
  var form1 = document.getElementById('track-order-form-1');
  if (form1) {
    form1.addEventListener('submit', function(e) {
      e.preventDefault();
      var orderNum = document.getElementById('order-number').value.trim();
      var contact = document.getElementById('order-contact').value.trim();
      if (!orderNum || !contact) {
        alert('Please enter both your order number and email/phone');
        return;
      }
      window.location.href = '/account/login';
    });
  }

});

  } catch(e) { console.error(e); }
})();
})();
